import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>

      <p>
        We respect your privacy and are committed to protecting your personal
        data. This Privacy Policy explains how we collect, use, and safeguard
        your information when you use our website.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We may collect name, email, phone number, and course preferences when
        you fill forms.
      </p>

      <h2>How We Use Data</h2>
      <p>
        - To provide training services<br />
        - To respond to inquiries<br />
        - To improve user experience
      </p>

      <h2>Data Protection</h2>
      <p>
        We do not sell or share your personal data with third parties.
      </p>
    </div>
  );
}